import { createApp } from 'vue';
import App from './app.vue';
import { createPinia } from 'pinia';
import router from './router';
import { AppInsights } from './appInsights';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css' // optional for styling

const appInsights = new AppInsights;

appInsights.loadAppInsights();
appInsights.trackPageView();
const pinia = createPinia();

createApp(App)
  .use(router)
  .use(pinia)
  .use(VueTippy, {
    directive: 'tippy', // => v-tippy
    component: 'tippy', // => <tippy/>
    componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
    defaultProps: {
      placement: 'auto-end',
      allowHTML: true,
    }, // => Global default options * see all props
  })
  .mount('#app');
